import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
  selector: 'app-add-btn',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddBtnComponent extends ButtonComponent {
  constructor() {
    super();
    this.icon = 'plus';
    this.label = $localize`Dodaj`;
    this.style = 'tertiary';
  }
}
